import { render, staticRenderFns } from "./contenedor.vue?vue&type=template&id=73dca32e&"
import script from "./contenedor.vue?vue&type=script&lang=js&"
export * from "./contenedor.vue?vue&type=script&lang=js&"
import style0 from "./contenedor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports